import React, { useEffect, useRef } from 'react';
import { Animated, InteractionManager } from 'react-native';

const FadeInAnimation = ({ delay = 0, duration = 1000, children }) => {
  // Create an animated value for opacity (starts at 0)
  const fadeAnim = useRef(new Animated.Value(0)).current;

  useEffect(() => {
  InteractionManager.runAfterInteractions(() => {
    Animated.timing(fadeAnim, {
      toValue: 1,
      duration,
      delay,
      useNativeDriver: true,
    }).start();
  });
}, [fadeAnim, delay, duration]);


  // Apply the animated opacity to the children components
  return (
    <Animated.View style={{ opacity: fadeAnim }}>{children}</Animated.View>
  );
};

export default FadeInAnimation;
